document.addEventListener('DOMContentLoaded', async (e) => {
  const projects = await getTreetrackerProjects();
  const currentProject = getCurrentProject(projects);
  console.log('projects', projects);

  const markers = [];
  const submitButton = document.getElementById('find-tree-project-button');

  submitButton.addEventListener('click', async (event) => {
    let input = document.getElementById('find-tree-project-input').value.replaceAll('EU', '');

    const project = projects.find((project) => {
      return (
        Number.parseInt(project.purchase_number_from) <= input && Number.parseInt(project.purchase_number_to) >= input
      );
    });
    const projectIndex = projects.findIndex((project) => {
      return (
        Number.parseInt(project.purchase_number_from) <= input && Number.parseInt(project.purchase_number_to) >= input
      );
    });

    if (project && projectIndex !== -1) {
      const foundMarker = markers.find((marker) => {
        return marker.projectHandle === project.handle;
      });

      clickMarker(foundMarker, markers);
      const projectLiquid = await getTreetrackerLiquidDetails(project.handle);

      showProject(projectLiquid);
    }
  });

  var myearth = new Earth('myearth', {
    location: { lat: 46.6, lng: 7.8 },
    mapLandColor: '#a5cb7b',
    mapSeaColor: '#bbe6e9',
  });

  myearth.addEventListener('ready', async function () {
    projects.forEach((project, productName) => {
      if (!project.gps_coordinates) {
        return;
      }
      const [lat, lng] = project.gps_coordinates.split(',');
      const mymarker = myearth.addMarker({
        location: { lat: lat, lng: lng },
        mesh: ['Marker'],
        color: '#3a6a39',
        scale: 0.5,
        hotspot: true,
        hotspotRadius: 0.75,
        hotspotHeight: 1.3,
        projectHandle: project.handle,
      });
      markers.push(mymarker);

      mymarker.addEventListener('click', async (e) => {
        const projectHandle = e.target.projectHandle;
        clickMarker(e.target, markers);
        const projectLiquid = await getTreetrackerLiquidDetails(projectHandle);
        showProject(projectLiquid);
      });
    });
    {
      const currentProjectHandle = currentProject.handle;
      const projectLiquid = await getTreetrackerLiquidDetails(currentProjectHandle);
      console.log('projectLiquid', projectLiquid);

      const foundMarker = markers.find((marker) => {
        return marker.projectHandle === currentProjectHandle;
      });
      clickMarker(foundMarker, markers);
      showProject(projectLiquid);
    }
  });

  const showProject = (project) => {
    const [lat, lng] = project.gps_coordinates.split(',');
    const location = { lat: Number.parseFloat(lat), lng: Number.parseFloat(lng) };
    if (
      myearth.goTo(location, {
        relativeDuration: 100,
        approachAngle: 12,
        end: function () {
          auto_rotate = false;
        },
      })
    ) {
      auto_rotate = true;
    }

    const imageSlider = document.getElementsByClassName('nik-standard-slider')[0].getElementsByClassName('inner')[0];
    imageSlider.innerHTML = '';
    const images = project.images.replaceAll(']', '').replaceAll('[', '').split(',');
    document.getElementsByClassName('dots')[0].innerHTML = '';
    for (let i = 0; i < images.length; i++) {
      const image = document.createElement('img');
      image.src = images[i];
      image.className =
        'nik-standard-slider-slide ec-w-full ec-aspect-video ec-object-cover ec-rounded-md ec-mr-4 ec-snap-center';
      imageSlider.appendChild(image);
      document.getElementsByClassName('dots')[0].innerHTML += `<span class="dot ec-w-2 ec-h-2 ec-rounded-full ec-block ec-mr-2 ${i === 0 ? 'active' : ''}"></span>`;
    }
    addSliderEventListender();
    addPropertyOrHide('treetracker-headline-desktop', project?.name);
    addPropertyOrHide('treetracker-headline-mobile', project?.name);
    addPropertyOrHide('treetracker-description-mobile', project?.description);
    addPropertyOrHide('treetracker-description-desktop', project?.description);
    addPropertyOrHide('treetracker-region', project?.region, true);
    addPropertyOrHide('treetracker-state', project?.state, true);
    addPropertyOrHide('treetracker-location', project?.location, true);
    addPropertyOrHide('treetracker-impact_areas', project?.impact_areas, true);
    addPropertyOrHide('treetracker-start_date_', project?.start_date_, true);
    addPropertyOrHide('treetracker-end_date_', project?.end_date_, true);
    addPropertyOrHide('treetracker-country', project?.country, true);
    let headline;
    if (window.innerWidth > 768) {
      headline = document.getElementById('treetracker-headline-desktop');
    } else {
      headline = document.getElementById('treetracker-headline-mobile');
    }
    // window.scrollTo({ top: headline.getBoundingClientRect().top - 100, behavior: 'smooth' });
  };
});

const addPropertyOrHide = (element, value, parent) => {
  try {
    const el = document.getElementById(element);

    if (value) {
      el.innerHTML = value;
      if (parent) {
        el.parentNode.classList.remove('ec-hidden');
      } else {
        el.classList.remove('ec-hidden');
      }
    } else {
      if (parent) {
        el.parentNode.classList.add('ec-hidden');
      } else {
        el.classList.add('ec-hidden');
      }
    }
  } catch (error) {
    console.log('error', error, element, value, parent);
  }
};

const clickMarker = (clickedMarker, markers) => {
  clickedMarker.color = '#ffffff';
  markers.forEach((marker) => {
    if (marker != clickedMarker) {
      marker.color = '#3a6a39';
    }
  });
};

const getTreetrackerProjects = async () => {
  try {
    const response = await fetch('https://nikinclothing-eu.myshopify.com/api/2023-07/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'f9556daad34afe91af82f12398167317',
      },
      body: JSON.stringify({
        query: '{\n  metaobjects(type: "tree_tracker_project", first:200) {edges {node {handle, fields {key value}}}}}',
      }),
    });
    if (response.ok) {
      const graphql = await response.json();
      const treetrackerProjects = graphql.data.metaobjects.edges.map((edge) => {
        const object = {
          handle: edge.node.handle,
        };
        edge.node.fields.map(({ key, value }) => {
          object[key] = value;
        });
        return object;
      });
      return treetrackerProjects;
    }
  } catch (error) {
    console.log('error', error);
  }
};

const getCurrentProject = (treeTrackerProjects) => {
  const currentProject = treeTrackerProjects.find((project) => {
    return project.current_project === 'true';
  });
  return currentProject;
};

const getTreetrackerLiquidDetails = async (projectHandle) => {
  try {
    const res = await fetch(`/products/treeshirt?view=treetracker-projects&handle=${projectHandle}`);
    if (!res.ok) {
      return;
    }
    const data = await res.json();
    return data.project;
  } catch (error) {
    console.log('error', error);
  }
};
